module.exports = __webpack_public_path__ + "static/media/no-image.625d1aff.jpg";